/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Status_FailedInputs */

const en_doc_status_failed = /** @type {(inputs: Doc_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classification failed`)
};

const pt_br2_doc_status_failed = /** @type {(inputs: Doc_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha na classificação`)
};

/**
* | output |
* | --- |
* | "Classification failed" |
*
* @param {Doc_Status_FailedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_status_failed = /** @type {((inputs?: Doc_Status_FailedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Status_FailedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_status_failed(inputs)
	return pt_br2_doc_status_failed(inputs)
});